module.exports = __webpack_public_path__ + "media/application/images/ui/filter-sort-ae066d176ee391229b49d5e5d103cb22.svg";